import { useRef } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import useModalEffect from '../../../hooks/useModalEffect'
import { useCustomChatStore } from '../../../stores/CustomChatStore'

const ModalSelectUser = () => {
    const modalRef = useRef<HTMLDivElement>(null)
    const { showModalSelectUser, setShowModalSelectUser } = useCustomChatStore()

    useModalEffect({
        showModal: showModalSelectUser,
        setShowModal: setShowModalSelectUser,
        modalId: 'modal-select-user'
    })


    return (
        <div className='modal' tabIndex={-1} id='modal-select-user' ref={modalRef}>
            <div className='modal-dialog modal-dialog-centered modal-lg'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <h5 className='modal-title'>Select User</h5>
                        <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={() => modalRef.current?.click()}>
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                    <div className='modal-body'>
                        {/* <SelectUser /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalSelectUser